import React, { Component } from 'react';
import autoBindMethods from 'class-autobind-decorator';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import SmartBool from '@mighty-justice/smart-bool';
import { FormModal } from '@mighty-justice/fields-ant';

export interface ILinkProps {
  [key: string]: any;
}

interface IProps {
  linkProps?: ILinkProps;
  linkText?: React.ReactNode;
  children?: React.ReactNode;
  ModalClass?: React.ComponentType<any> | React.FunctionComponent<any>;
  passThroughProps?: { [key: string]: any, onCancel?: () => void, onSuccess?: () => void };
}

@autoBindMethods
@observer
class ModalLink extends Component<IProps> {
  @observable public isVisible = new SmartBool();

  private onSuccess () {
    const { passThroughProps } = this.props;
    if (passThroughProps && passThroughProps.onSuccess) { passThroughProps.onSuccess(); }
    this.isVisible.setFalse();
  }

  private onCancel () {
    const { passThroughProps } = this.props;
    if (passThroughProps && passThroughProps.onCancel) { passThroughProps.onCancel(); }
    this.isVisible.setFalse();
  }

  private async onClick (event: any) {
    const { linkProps } = this.props;
    if (linkProps && linkProps.onClick) { await linkProps.onClick(event); }
    this.isVisible.setTrue();
  }

  public render () {
    const { linkProps, linkText, children, ModalClass, passThroughProps } = this.props
      , Modal = ModalClass ? ModalClass : FormModal as any;

    return (
      <>
        <a {...linkProps} onClick={this.onClick} children={linkText || children} />

        {this.isVisible.isTrue && (
          <Modal
            {...passThroughProps}
            isVisible={this.isVisible}
            onCancel={this.onCancel}
            onSuccess={this.onSuccess}
          />
        )}
      </>
    );
  }
}

export default ModalLink;
